import { render } from "./collection-and-billing-details-card.vue?vue&type=template&id=657c9559"
import script from "./collection-and-billing-details-card.vue?vue&type=script&lang=js"
export * from "./collection-and-billing-details-card.vue?vue&type=script&lang=js"

import "./collection-and-billing-details-card.vue?vue&type=style&index=0&id=657c9559&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__